module.exports = __webpack_public_path__ + "90d9244c4454d098fe77533288e5d0e9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/hyperspace5.gif
// module id = 227
// module chunks = 0